import { OptionType } from '@evinced-private/ui-common';

import { IMfaLabelOptions } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { transformMfaLabelOptionsResults } from 'src/apps/mfa/services/queries/label-options/helpers/transformResults';
import { MfaLabelOptionsQuery } from 'src/apps/mfa/services/queries/label-options/MfaLabelOptions.generated';
import { MfaLabelOptions } from 'src/apps/mfa/services/queries/label-options/MfaLabelOptions.gql';
import { transformMfaOwnerOptionsResults } from 'src/apps/mfa/services/queries/owner-options/helpers/transformResults';
import { MfaOwnerOptionsQuery } from 'src/apps/mfa/services/queries/owner-options/MfaOwnerOptions.generated';
import { MfaOwnerOptions } from 'src/apps/mfa/services/queries/owner-options/MfaOwnerOptions.gql';
import { buildMfaSessionsQueryVariables } from 'src/apps/mfa/services/queries/sessions/helpers/buildVariables';
import { transformMfaSessionsResults } from 'src/apps/mfa/services/queries/sessions/helpers/transformResults';
import { MfaSessionsQuery } from 'src/apps/mfa/services/queries/sessions/MfaSessions.generated';
import { MfaSessions } from 'src/apps/mfa/services/queries/sessions/MfaSessions.gql';
import { buildMfaUsageDataVariables } from 'src/apps/mfa/services/queries/usage-data/helpers/buildVariables';
import { transformMfaUsageDataResults } from 'src/apps/mfa/services/queries/usage-data/helpers/transformResults';
import { MfaUsageDataQuery } from 'src/apps/mfa/services/queries/usage-data/MfaUsageData.generated';
import { MfaUsageData } from 'src/apps/mfa/services/queries/usage-data/MfaUsageData.gql';
import { TMfaSessionsResult } from 'src/apps/mfa/types/MfaDashboardServiceTypes';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { SummaryItem } from 'src/common/interfaces/SummaryItem';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';
import { ITableQueryParams } from 'src/common/types/TableQueryTypes';

export const getMfaSessions = async (params: ITableQueryParams): Promise<TMfaSessionsResult> => {
	try {
		const variables = buildMfaSessionsQueryVariables(params);
		const result = await gqlClient.request<MfaSessionsQuery>(MfaSessions, variables);

		return transformMfaSessionsResults(result);
	} catch (error) {
		Logger.error('MfaDashboardService -> getMfaSessions failed with an error:', error);
		throw error;
	}
};

export const getMfaSummaryData = async (filters: IFilterOptions): Promise<SummaryItem[]> => {
	try {
		const variables = buildMfaUsageDataVariables(filters);
		const result = await gqlClient.request<MfaUsageDataQuery>(MfaUsageData, variables);

		return transformMfaUsageDataResults(result, filters.sessionsPeriod?.[0]);
	} catch (e) {
		Logger.error('MfaDashboardService -> getMfaSummaryData GraphQL query failed:', e);
		throw e;
	}
};

export const getMfaOwnerOptions = async (): Promise<OptionType[]> => {
	try {
		const result = await gqlClient.request<MfaOwnerOptionsQuery>(MfaOwnerOptions);

		return transformMfaOwnerOptionsResults(result);
	} catch (error) {
		Logger.error('MfaDashboardService -> getMfaOwnerOptions GraphQL failed:', error);
		throw error;
	}
};

export const getMfaLabelsOptions = async (): Promise<IMfaLabelOptions[]> => {
	try {
		const result = await gqlClient.request<MfaLabelOptionsQuery>(MfaLabelOptions);

		return transformMfaLabelOptionsResults(result);
	} catch (error) {
		Logger.error('MfaDashboardService -> getMfaLabelsOptions GraphQL failed:', error);
		throw error;
	}
};
